import { apiService } from "../services/api.service";

export const uzivateliaController = {
    authenticate,
    getAll,
    getById
};

function authenticate(username, password, sklad) {
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, sklad })
    };

    return apiService.fetchApiRequest("/api/user/authenticate", false, requestOptions);
}

function getAll() {
    return apiService.fetchApiRequest("/api/user/getall");
}

function getById(id) {
    return apiService.fetchApiRequest(`/api/user/getbyid/${id}`);
}



// WEBPACK FOOTER //
// ./src/controllers/uzivatelia.controller.js